import ValueX from '../types/ValueX';

export default class LocationX extends ValueX {
    constructor(constructJson) {
        super(constructJson, 'location', LocationX);
    }
}
